module.exports = __webpack_public_path__ + "img/ez-slot-ic-contact-line.9718808d.png";